
import Vue from "vue";

export default Vue.extend({
  name: "TransitionExpand",
  functional: true,
  render(createElement, context) {
    const data = {
      props: {
        name: "expand"
      },
      on: {
        afterEnter(element: any) {
          // eslint-disable-next-line no-param-reassign
          element.style.height = "auto";
        },
        enter(element: any) {
          const { width } = getComputedStyle(element);

          /* eslint-disable no-param-reassign */
          element.style.width = width;
          element.style.position = "absolute";
          element.style.visibility = "hidden";
          element.style.height = "auto";
          /* eslint-enable */

          const { height } = getComputedStyle(element);

          /* eslint-disable no-param-reassign */
          element.style.removeProperty("width");
          element.style.removeProperty("position");
          element.style.removeProperty("visibility");
          element.style.height = 0;
          /* eslint-enable */

          // Force repaint to make sure the
          // animation is triggered correctly.
          // eslint-disable-next-line no-unused-expressions
          getComputedStyle(element).height;

          setTimeout(() => {
            // eslint-disable-next-line no-param-reassign
            element.style.height = height;
          });
        },
        leave(element: any) {
          const { height } = getComputedStyle(element);

          // eslint-disable-next-line no-param-reassign
          element.style.height = height;

          // Force repaint to make sure the
          // animation is triggered correctly.
          // eslint-disable-next-line no-unused-expressions
          getComputedStyle(element).height;

          setTimeout(() => {
            // eslint-disable-next-line no-param-reassign
            element.style.height = 0;
          });
        }
      }
    };

    return createElement("transition", data, context.children);
  }
});
